import{asChildPropDef as r}from"../props/as-child.prop.js";import{textWrapPropDef as o}from"../props/text-wrap.prop.js";import{truncatePropDef as p}from"../props/truncate.prop.js";const t={...r,...p,...o};export{t as emPropDefs};
//# sourceMappingURL=em.props.js.map
